import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

export class SSOService {
  public static ssoEnabled(): void {
    HttpService.get(Endpoint.GET.SSO_ENABLED).then((resp) => {
      if (resp.body) {
        HistoryService.redirect('/login');
      }
    }).catch(() => HistoryService.redirect('/login')
    );
  }

}
